"use client";

import { OpenAccountUser } from "@/types/openAccount";

import { useOpenAccount } from "@/context/openAccount";

import LookupButton from "@/components/lookup/button";
import StepButtonWrapper from "@/components/wrapper/stepButton";
import LoginButton from "@/components/loginButton";

export default function VerifyButton() {
  const { errors, getAccountSetup, openAccountUser } = useOpenAccount();

  if (openAccountUser?.needsSetup === false) return <LoginButton />;

  return (
    <StepButtonWrapper
      button={
        !openAccountUser?.token ? (
          // no token means we need to get account setup data
          <LookupButton<OpenAccountUser>
            entity={openAccountUser}
            errors={errors}
            onClick={getAccountSetup}
            tooltipSuffix="to complete your account verification"
          />
        ) : undefined
      }
    />
  );
}
